import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Dashboard from './components/Dashboard/Dashboard';

function App({ nonce }: { nonce: string }) {

  useEffect(() => {

    const script = document.createElement("script");
    script.setAttribute("nonce", nonce); 
    document.body.appendChild(script);
  }, [nonce]);


  return (
    <>
      <div className='clsMain'>
        <BrowserRouter>
        <Dashboard />
        </BrowserRouter>
      </div>
    </>
  )
}

export default App;